// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportObjects = {
	48361: function() {
		return {
			"./image_annotator_util_bg.js": {
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[69577].exports;
					return wasmImportedFuncCache0["Qn"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"9729": [
		48361
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"9729":{"48361":"3314327559f83dadbabb"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};